module.exports = __webpack_public_path__ + "img/step_info.183d1428.png";